﻿import {applyMiddleware, combineReducers, createStore, compose} from 'redux';
import { thunk } from 'redux-thunk';

import {
    pageIsLoading,
    pageError,
    pageHasErrored,
    pageCurrentStep
} from './reducers';

import {
    insuranceGuideFormData
} from '../Pages/InsuranceGuidePage/State/reducers';

import {
    retirementGuideFormData,
    retirementGuideChartData
} from '../Pages/RetirementGuidePage/State/reducers';

import {
    faqData
} from '../Features/CategorizedFAQQuestionBlock/State/reducers';

export function configureStore(initialState) {
    // enable redux devtools if debug global is set
    const composeEnhancers = window._bazDebug
        && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
            ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
                serialize: {
                    options: true
                }
            })
            : compose;

    const rootReducer = combineReducers({
        pageIsLoading,
        pageError,
        pageHasErrored,
        pageCurrentStep,

        insuranceGuideFormData,

        retirementGuideFormData,
        retirementGuideChartData,

        faqData
    });

    return createStore(
        rootReducer,
        initialState,
        composeEnhancers(applyMiddleware(thunk))
    );
};
